import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/popularOffers';

export const POPULAR_OFFERS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const POPULAR_OFFERS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const POPULAR_OFFERS_VIEW = `${rootActionPath}/VIEW`;
